import styled, { css } from 'styled-components';

const Main_loading = css`
  opacity: 0.7;

  button {
    cursor: wait;

    &:disabled {
      cursor: wait;
    }
  }
`;

export const Main = styled.div<{ $loading?: boolean }>`
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.neutral_100};
  flex-wrap: wrap;
  flex: 1;
  padding: 16px 0px 8px;

  ${({ $loading }) => $loading && Main_loading}
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  &:first-of-type {
    gap: 8px;
    max-width: 140px;
  }

  &:last-of-type {
    gap: 32px;
    justify-content: flex-end;
    flex: 1;
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  min-width: 24px;
  height: 24px;
  min-height: 24px;
  background-color: transparent;

  svg {
    width: 100%;
    height: 100%;
  }
`;
